import React, {useEffect, useReducer, useState} from "react";
import "../../../GlobalStyles.css";
import "./Questionnaire.css";
import Loader from "../../../Loader/Loader";
import {Button} from "@mui/material";
import {useLocation, useNavigate} from "react-router-dom";
import {QuestionnaireHelper} from "../../../Utilities/CmsHelpers";
import QuestionnaireService from "../../../../services/QuestionnaireService";
import CheckBox from "../../components/CheckBox/CheckBox";
import { styled } from '@mui/system';
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/material";
import {useCms} from "../../../../context/CmsContext";
import {useTranslation} from "react-i18next";
import GenericError from "../../../Utilities/GenericError";
import PopUp from "../../../Utilities/PopUp";

const TextareaAutosize = styled(BaseTextareaAutosize)(
    ({ theme }) => `
    box-sizing: border-box;
    width: 100%;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    padding: 16px;
    border-radius: 8px;
    color: #fff;
    background: #000;
  `,
);

function Questionnaire() {
    let navigate = useNavigate();

    const initialFlowState = {
        onSkipAction: null,
        submit: {
            action: async (q, values)=>{
                return QuestionnaireService.submitQuestionnaire({questionnaireId:q, answers:values})
                    .then(response =>{
                    })
                    .catch(error =>{
                        console.error(error);
                    })
            },
            locale: "questionnaireSubmitButton"
        },
    }

    function flowReducer(state, action) {
        switch (action.flow) {
            case process.env.REACT_APP_REGISTRATION_QUESTIONNAIRE:
                const identifier= process.env.REACT_APP_REGISTRATION_QUESTIONNAIRE
                return {
                    onSkipAction: async ()=>{
                        return QuestionnaireService.submitQuestionnaire({
                            questionnaireId: identifier,
                            answers:[]
                        })
                            .then(response =>{
                                navigate("/PickProgram")
                            })
                            .catch(error =>{
                                setSubmitError(error.response.data.code)
                                setLoading(false)
                                console.error(error);
                            })
                    },
                    submit: {
                        action: async (q, values)=>{
                            return QuestionnaireService.submitQuestionnaire({
                                questionnaireId: identifier,
                                answers:values
                            })
                                .then(response =>{
                                    navigate("/PickProgram")
                                })
                                .catch(error =>{
                                    setSubmitError(error.response.data.code)
                                    setLoading(false)
                                    console.error(error);
                                })
                        },
                        locale: "questionnaireRegisterSubmitButton"
                    },
                };
            default:
                return {
                    ...initialFlowState,
                }
        }
    }

    const [state, dispatch] = useReducer(flowReducer, initialFlowState);

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const { t } = useTranslation();

    const [submitError, setSubmitError] = useState("");

    //this page should not use context loading since on submit we need to start loading and navigate
    const [loading, setLoading] = useState(true);

    const { q } = location.state ?? {};
    const currentQ = q ?? searchParams.get("q") ?? undefined;

    if(!(!!currentQ)){
        navigate("/")
    }

    const [answersArray, setAnswersArray] = useState([])
    const [checkboxes, setCheckboxes] = useState({});
    const [textArea, setTextArea] = useState("")


    const {questionnaireData} = useCms();
    const [questionData, setQuestionData] = useState(undefined)

    useEffect(()=>{
        setQuestionData(QuestionnaireHelper.getQuestionnaire(questionnaireData, currentQ))
    }, [questionnaireData, currentQ])//eslint-disable-line react-hooks/exhaustive-deps

    useEffect(()=>{
        dispatch({flow: currentQ})
    }, [currentQ])

    useEffect(()=>{
        setLoading(true)
        if(!!questionData)
            if(!(!!questionData.title) || !(!!questionData.question)){
                navigate("/")
            }else {
                setAnswersArray(questionData?.randomize_order ? arraySuffler(questionData?.Answers) : questionData?.Answers)
                setLoading(false)
            }
    }, [questionData]) //eslint-disable-line react-hooks/exhaustive-deps

    const onSkip = async ()=>{
        setLoading(true)
        if(state.onSkipAction){
            state.onSkipAction()
        }
        setLoading(false)
    }

    const onSubmit = async ()=>{
        setLoading(true);
        const checkedValues = [...Object.keys(checkboxes)
            .filter(key =>  key !== "Other" && checkboxes[key])
            .map(key => key.substring(0, 50)),
            ...(checkboxes["Other"] ? ["Other: "+textArea] : [])];

        return state.submit.action(currentQ, checkedValues);
    }

    const arraySuffler = (array)=>{
        if(!!array){
            const newArray = [...array];
            for (let i = newArray.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
            }
            return newArray;
        }else {
            return []
        }
    }

    const handleCheckboxChange = (name, checked) => {
        setCheckboxes({
            ...checkboxes,
            [name]: checked
        });
    };

    const canSubmit =
        !!Object.keys(checkboxes).filter(key => checkboxes[key]).length &&
        (!checkboxes["Other"] || textArea.trim().length > 0);
    return (
        <>
            {loading ? (
                <Loader/>
            ) : (
                <div className="questionnaire-wrapper">
                    <div className="questionnaire-header">
                        <h1>{questionData?.title}</h1>
                        <h2>{questionData?.description}</h2>
                    </div>
                    <div className={"questionnaire-content"}>
                        <div className={"questionnaire-questions"}>
                            <div>
                                <h2>{questionData?.question}<span> {questionData?.questionInstruction}</span></h2>
                            </div>
                            <ul>
                                {answersArray.map((item, index) =>
                                    <li key={index}>
                                        <CheckBox text={item.answer}
                                                  id={item.answer}
                                                  checked={checkboxes[item.answer] || false}
                                                  action={(e)=>{handleCheckboxChange(item.answer, e.target.checked)}}>
                                        </CheckBox>
                                    </li>
                                )}
                                {questionData?.otherAnswerPlaceholder &&
                                    <li>
                                        <CheckBox
                                            id={"Αλλο"}
                                            checked={checkboxes["Other"] || false}
                                            action={(e)=>{handleCheckboxChange("Other", e.target.checked)}}>
                                            <div className={"questionnaire-other-wrapper"}>
                                                <span>{t("questionaireAnswerOther")}</span>
                                                {(checkboxes["Other"] || false) &&
                                                    <div className={"questionnaire-other-hidden-wrapper"}>
                                                        <TextareaAutosize minRows={3} maxLength={process.env.REACT_APP_QUESTIONNAIRE_MAX_CHARS ?? 200} placeholder={questionData?.otherAnswerPlaceholder} value={textArea} onChange={(e)=>{setTextArea(e.target.value)}} />
                                                    </div>
                                                }
                                            </div>
                                        </CheckBox>
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
                    <div className={"questionnaire-submit-wrapper"}>
                        {!!state?.onSkipAction &&
                            <Button variant="text" color="secondary" onClick={()=>{onSkip()}}>
                                {t("questionnaireSkipButton")}
                            </Button>
                        }
                        <Button variant="contained" color="primary" disabled={!canSubmit} onClick={()=>onSubmit()}>
                            {t(state.submit?.locale)}
                        </Button>
                    </div>
                    <PopUp
                        openPopUp={submitError !== ""}
                        setOpenPopUp={() => {setSubmitError("")}}
                        showCloseButton={true}
                        outlined={false}
                        maxWidth="md"
                        error={false}
                        closeWhenClickedOutside={true}>
                        <GenericError
                            setClose={()=>{setSubmitError("")}}
                            success={true}
                            showIcon={false}>
                            {t("questionnaireError"+submitError)}
                        </GenericError>
                    </PopUp>
                </div>
            )}
        </>
    );
}

export default Questionnaire;
